import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Icon/sgds-icon";
import { register } from "../../utils/ce-registry";

register("sgds-icon", Component);

export default createComponent({
  react: React,
  tagName: "sgds-icon",
  elementClass: Component,
  events: {}
});
